import StoryPiece from './StoryPiece.vue';

export default StoryPiece;
